import { RootState, ThunkDispatch } from "core-integration/src/store";
import { getElementsById } from "core-integration/src/store/elements/reducers";
import { showElementSummary } from "core-integration/src/store/elements/thunks";
import { IElementsById } from "core-integration/src/store/elements/types";
import { IPickLight } from "core-integration/src/store/entries/types";
import * as React from "react";
import { connect } from "react-redux";
import styled from "styled-components";
import ElementDialogButton from "../ElementDialogButton";
import ElementShirt from "../ElementShirt";
import { Controls } from "../Pitch";
import { UnstyledButton } from "../Utils";
import StatusPitchElementData from "./StatusPitchElementData";

const StatusPitchElementWrap = styled.div`
  margin: 0 0.2rem;
  padding: 0.4rem 0;
  border-radius: 0.4rem;
  align-items: stretch;
`;

const StyledStatusPitchElement = styled.div`
  position: relative;
  width: 7rem;
  height: 7.4rem;
  margin: auto;
  padding-top: 0.7rem;
  border: ${({ theme }) => theme.borders[6]};
  border-radius: ${({ theme }) => theme.radii[1]};
  background: ${({ theme }) => theme.colors.blurBackground};
  backdrop-filter: blur(2px);
  text-align: center;

  @media (min-width: ${({ theme }) => theme.breakpoints[1]}) {
    width: 10.5rem;
    height: 9.5rem;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints[4]}) {
    width: 12.5rem;
    height: 13rem;
  }
`;

const StyledInfoControl = styled.div`
  @media (min-width: ${({ theme }) => theme.breakpoints[3]}) {
    position: absolute;
    top: 5px;
    right: 5px;
  }
`;

interface IPropsFromState {
  elementsById: IElementsById;
}

interface IPropsFromDispatch {
  showElementDialog: (elementId: number) => void;
}

interface IOwnProps {
  pick: IPickLight;
  renderElementMenu: () => void;
  renderPickValue: (pick: IPickLight) => React.ReactNode;
}

type Props = IPropsFromState & IPropsFromDispatch & IOwnProps;

const Squad: React.FC<Props> = ({
  pick,
  elementsById,
  renderElementMenu,
  renderPickValue,
}) => {
  const element = elementsById[pick.element];

  return (
    <StatusPitchElementWrap>
      <StyledStatusPitchElement>
        <UnstyledButton type="button" onClick={renderElementMenu}>
          <ElementShirt
            elementId={element.id}
            sizes="(min-width: 1024px) 115px, (min-width: 610px) 90px, 50px"
          />
          <StatusPitchElementData
            element={element}
            value={renderPickValue(pick)}
          />
        </UnstyledButton>
        <Controls>
          <StyledInfoControl>
            <ElementDialogButton elementId={pick.element} />
          </StyledInfoControl>
        </Controls>
      </StyledStatusPitchElement>
    </StatusPitchElementWrap>
  );
};

const mapStateToProps = (state: RootState): IPropsFromState => ({
  elementsById: getElementsById(state),
});

const mapDispatchToProps = (dispatch: ThunkDispatch): IPropsFromDispatch => ({
  showElementDialog: (elementId) => dispatch(showElementSummary(elementId)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Squad);
